import LTR from "@brand-icons/ploom/ui-info-circle-bold/ui-info-circle-bold-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiInfoCircleBoldIcon = iconFactory("UiInfoCircleBoldIcon", LTR);
